import { createApi } from '@reduxjs/toolkit/query/react'
import getCustomFetchBase from '../custom-fetch-base'
import Strapi, { EndpointQueryParameters } from '../../types/strapi/strapi'
import getQuery from '../../helpers/api/get-query'
import Pantone from '../../types/api/pantone'

export const pantonesApi = createApi({
    reducerPath: 'pantonesApi',
    baseQuery: getCustomFetchBase({ baseUrl: import.meta.env.VITE_API_URL }),
    endpoints: builder => ({
        getPantones: builder.query<Strapi<Pantone>, EndpointQueryParameters | void>({
            query: getQuery('/pantones'),
        }),
    }),
})

export const { useGetPantonesQuery } = pantonesApi
